module.exports = __webpack_public_path__ + "static/esb-simple-ed8b27bdf474b593981e13b2fc002f93.svg";